import React, { useState } from "react";
import ExpandIcon from "../../../assets/icon/expand.svg";
import MinimizeIcon from "../../../assets/icon/minimize.svg";
import aknowledgeIcon from "../../../assets/icon/aknowledge-icon.svg";
import { Button } from "reactstrap";

const DrugUtilPopUp = ({ openCliams }) => {
  const [expand, setExpand] = useState(false);

  const boxHeading = [
    {
      id: 1,
      heading: "Drug-Drug Interaction",
      headingTwo: "Override",
      subHeader: "Drug Interaction with TRAZODONE Detected",
      color: "#F8CFCF",
      headColor: "#E54141",
      fontWeight: 600,
      desColor: "#757575",
      borderColor: "2px solid #E54141",
      message:
        "Serotonergic effects of trazodone/norepinephrine reuptake inhibition (SNRIs) may be additive. The risk of serotonin syndrome/toxicity may be increased.",
    },
    {
      id: 2,
      heading: "Drug-Drug Interaction",
      headingTwo: "Override",
      subHeader: "Drug Interaction with PANTOPRAZOLE TAB 40MG Detected",
      color: "#FFDEBF",
      headColor: "#FF7C00",
      desColor: "#757575",
      borderColor: "2px solid #FF7C00",
      message:
        "Pharmacologic and effects plasma concentrations of VENLAFAXINE HYDROCHLORIDE may be increased by omeprazole pantoprazole.",
    },
    {
      id: 3,
      heading: "Precautions",
      headingTwo: "Override",
      subHeader: "",
      color: "#CFDCF8",
      headColor: "#4175E5",
      desColor: "#4175E5",
      borderColor: "2px solid #419BE5",
      message:
        "Venafaxine HCI should be used with extreme caution in Cerebrovascular Disease. Use with caution.",
    },
    {
      id: 4,
      heading: "Dose Screening",
      headingTwo: "",
      subHeader: "",
      color: "#CCE5BF",
      headColor: "#339900",
      desColor: "#339900",
      borderColor: "2px solid #339900",
      message: "No dosing issues have been identified",
    },
  ];

  return (
    <div
      className="drugContainer d-flex flex-column bg-white align-items-end"
      style={{ width: expand ? "82vw" : "50vw" }}
    >
      <div className="expand-btn" onClick={() => setExpand(!expand)}>
        <img src={expand ? MinimizeIcon : ExpandIcon} alt="not available" />
        Expand Details
      </div>
      <div
        style={{
          padding: "8px",
          width: expand ? "82vw" : "50vw",
          height: "auto",
        }}
      >
        {boxHeading.map((name) => (
          <div
            className="heading"
            style={{
              backgroundColor: name.color,
              border: name.borderColor,
            }}
          >
            <div className="headerText">
              <div
                style={{
                  color: name.headColor,
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                {name.heading}
              </div>
              <div className="headTwo">{name.headingTwo}</div>
            </div>
            <div className="subHeader" style={{ color: name.headColor }}>
              {name.subHeader}
            </div>
            <div
              style={{
                color: name.desColor,
                fontSize: "12px",
                fontWeight: 500,
                paddingRight: "15px",
              }}
            >
              {name.message}
            </div>
          </div>
        ))}
      </div>
      <div
        style={{
          // padding: "8px",
          width: expand ? "82vw" : "50vw",
          height: "auto",
        }}
        className="drugfooter p-3"
        onClick={() => openCliams(true)}
      >
        <Button color="primary">
          {" "}
          <img src={aknowledgeIcon} /> Acknowledge All
        </Button>
      </div>
    </div>
  );
};

export default DrugUtilPopUp;
